import { assign, findKey } from 'lodash';
import { parse, stringify } from 'query-string';
import jsesc from 'jsesc';
import { COVERME_ROUTES, SUPPORTED_LOCALES } from '@trip-ux/constants';

export const flipLanguage = (previousLang: string) => {
  const newLang = previousLang === SUPPORTED_LOCALES.ENGLISH ? SUPPORTED_LOCALES.FRENCH : SUPPORTED_LOCALES.ENGLISH;
  const currentParams = parse(window.location.search);
  const updatedParams = {
    ...currentParams,
    lang: newLang
  };

  const newQueryString = stringify(updatedParams);
  window.location.search = `?${newQueryString}`;
};


export const assignQueryParam = (lang: string) => {
  const queryParams = JSON.parse(jsesc(parse(location.search), { json: true, isScriptContext: true }));
  location.search = stringify(assign({}, queryParams, { lang }));
};

export enum DATE_PICKER_CONSTANTS {
  ADD_DAY = 1,
  REDUCE_DAY = -1,
  ADD_WEEK = 7,
  REDUCE_WEEK = -7,
  ZERO = 0,
  ONE = 1
}

export const DATE_PICKER_WEEKS_FIVE = [0, 1, 2, 3, 4];
export const DATE_PICKER_WEEKS_SIX = [...DATE_PICKER_WEEKS_FIVE, 5];
export const DATE_PICKER_FIVE_WEEK_GRID = 35;
export const DATE_PICKER_SIX_WEEK_GRID = 42;
export const DATE_PICKER_MAX_DATE_MONTH = 11;
export const DATE_PICKER_NUMBER_OF_MONTH = 12;
export const DATE_PICKER_DAYS_IN_WEEK = 7;
export const DATE_PICKER_ZERO = 0;

export enum TOOLTIP_CONSTANTS {
  OFFSET_BASE_X = 20,
  OFFSET_BASE_Y = 20,
  ZERO = 0,
  ONE = 1,
  TWO = 2,
  THREE = 3,
  HALF_BUBBLE_OFFSET = 10,
  FLOAT_Y_WIDTH = 60,
  TOP_OFFSET = 5,
  RATIO_HALF = 0.5,
  RATIO_ONE_THIRD = 0.3,
  RATIO_TWO_THIRDS = 0.7
}

export enum DROP_DOWN_HEIGHTS {
  LIST = 44,
  LIST_BOX_MAX = 220,
  LIST_INDEX = 2
}

export const RADIO_BUTTON_VERTICAL_WIDTH = 575;

export enum TOOLTIP_SIDES {
  TOP = 'top',
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  BOTTOM = 'bottom',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
  LEFT = 'left',
  RIGHT = 'right'
}

export enum SCROLL_DIRECTION {
  UP = 'up',
  DOWN = 'down'
}

export enum PHONE_TYPE {
  NUMBER = 'Phone Number',
  EXTENSION = 'Extension'
}

export enum NavIds {
  MyAdvisorReports = 'myAdvisorReports',
  Resources = 'resources',
  advisorAdmin = 'advisorAdmin'}
